module.exports = __webpack_public_path__ + "img/45.b388f743.svg";